import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { SharedModule } from '../../shared/shared.module';

import {
    ActionListItemActionComponent,
    ActionListItemComponent,
    AnimatedCheckmarkComponent,
    ContextFrameClosedViewDirective,
    ContextFrameComponent,
    DropListModule,
    ExpansionPanelComponent,
    FacetChipDirective,
    LoadingSlateComponent,
} from '@exl-ng/mulo-common';
import {
    CenteredBlockLayoutComponent,
    SideMainLayoutComponent,
} from '@exl-ng/mulo-views';

import { CvCreationComponent } from './cv-creation.component';
import { CvTemplateComponent } from './cv-template/cv-template.component';
import { CvInfoComponent } from './cv-info/cv-info.component';
import { CvFormatComponent } from './cv-format/cv-format.component';
import { CvMapFilterPipe } from '../../shared/pipes/cv-map-filter.pipe';
import { EspDatepickerModule } from '../../bits/esp-datepicker/esp-datepicker.module';
import { ArcviewModule } from '../../parts/arcview/arcview.module';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        CdkAccordionModule,
        SideMainLayoutComponent,
        CenteredBlockLayoutComponent,
        ContextFrameComponent,
        ContextFrameClosedViewDirective,
        DropListModule,
        ExpansionPanelComponent,
        FacetChipDirective,
        AnimatedCheckmarkComponent,
        EspDatepickerModule,
        CvMapFilterPipe,
        ArcviewModule,
        ActionListItemComponent,
        ActionListItemActionComponent,
        LoadingSlateComponent,
        CvCreationComponent,
        CvTemplateComponent,
        CvInfoComponent,
        CvFormatComponent,
    ],
    exports: [
        CvCreationComponent,
        CvTemplateComponent,
        CvInfoComponent,
        CvFormatComponent,
    ],
})
export class CvModule {}
